// import { useState, useRef, useEffect } from 'react';

// const ImageScroll = ({ data }) => {
//     const containerRef = useRef(null);

//     // Scroll speed in milliseconds
//     const scrollSpeed = 30;

//     const startAutoScroll = () => {
//         const container = containerRef.current;
//         const scrollWidth = container.scrollWidth - container.clientWidth;
//         let scrollAmount = 0;

//         const autoScroll = setInterval(() => {
//             if (scrollAmount >= scrollWidth) {
//                 // Reset scroll back to start
//                 container.scrollLeft = 0;
//                 scrollAmount = 0;
//             } else {
//                 // Scroll to the right
//                 container.scrollLeft += 1;
//                 scrollAmount += 1;
//             }
//         }, scrollSpeed);

//         return () => clearInterval(autoScroll);
//     };

//     useEffect(() => {
//         const stopAutoScroll = startAutoScroll();

//         // Cleanup interval when component unmounts
//         return stopAutoScroll;
//     }, [data]);

//     return (

//                 <div
//                     className="overflow-x-scroll scrollbar-hide flex space-x-4 w-full"
//                     ref={containerRef}
//                 >
//                     {data.map((item, index) => (
//                         <div
//                             key={index}
//                             className="min-w-[480px] bg-[#ffff] border-[2px] border-gray-300 flex flex-col gap-2  p-4 rounded-[10px]"
//                         >
//                            <img src={item.img} alt="lagos-logo" className='h-[150px]' />
//                         </div>
//                     ))}
//                 </div>

//     );
// };

// export default ImageScroll;
// i
import { useState } from "react";

const ImageScroll = ({ data }) => {
  const [selectedCategory, setSelectedCategory] = useState("Category");
  const [selectedProduct, setSelectedProduct] = useState("Product");
  const [selectedStatus, setSelectedStatus] = useState("Status");

  const handleClick = (id) => {
    console.log("Clicked item ID:", id);
  };

  const payload = {
    category: selectedCategory !== "Category" ? selectedCategory : null,
    product: selectedProduct !== "Product" ? selectedProduct : null,
    status: selectedStatus !== "Status" ? selectedStatus : null,
  };
  console.log("Payload:", payload);

  return (
    <div className="relative w-full flex flex-col gap-6">
      <div className="marquee-container">
        <div className="marquee-content">
          {data.map((item, index) => (
            <div
              key={index}
              className="marquee-item min-w-[480px] bg-[#ffff] border-gray-300 flex flex-col gap-2"
            >
              <div className="flex gap-2 items-center">
                <img
                  src={item.img}
                  alt="event-image"
                  className="w-full h-[150px]"
                />
              </div>
            </div>
          ))}
          {/* Clone the content for continuous scrolling */}
          {data.map((item, index) => (
            <div
              key={`clone-${index}`}
              className="marquee-item min-w-[480px] bg-[#ffff] border-gray-300 flex flex-col gap-2"
            >
              <div className="flex gap-2 items-center">
                <img
                  src={item.img}
                  alt="event-image"
                  className="w-full h-[150px]"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageScroll;
